export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--M.b69ddcc7.png";